module.exports = __webpack_public_path__ + "static/img/dsf_09.6b705bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dsfRobot/dsf_09.png
// module id = 0iyD
// module chunks = 46